import { Box, styled } from '@mui/material';

export const StyledFlightsInformationBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export const StyledFlightDataBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
`;
export const StyledFlightDataContainer = styled('div')`
    width: 100%;
`;
export const StyledPaxDataBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 55%;
    justify-content: space-around;
    align-items: center;
    border: 1px solid #b6d2e5;
    border-radius: 5px;
`;
export const StyledDataBox = styled(Box)`
    font-weight: bold;
    font-size: 18px;
    display: flex;
    justify-content: center;
`;
export const StyledDateDataBox = styled('div')`
    font-weight: normal;
    font-size: 14px;
    display: flex;
    justify-content: center;
    padding-bottom: 5px;
`;
export const StyledArrivalDataBox = styled(Box)<{ isborderright?: string }>`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    padding-bottom: 20px;
    ${({ isborderright }) => (isborderright ? 'border-right: 1px solid #b6d2e5;' : '')};
`;
export const StyledDepartureDataBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    padding-bottom: 20px;
`;
export const StyledTitleDataBox = styled(Box)`
    color: #acacac;
    font-size: 13px;
    display: flex;
    justify-content: center;
`;
export const StyledDataZoneBox = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
export const StyledEndTimeContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    width: 100%;
`;
